import React, { useContext, useEffect, useState, useRef } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import { Nav, Navbar } from 'react-bootstrap';
import { useTheme } from '@sumologic/yama-ds-components/hooks';

import { formatDuration, intervalToDuration } from 'date-fns';

import { Tooltip } from '@sumologic/yama-ds-components';

import User from '~/models/User';

//import WebSocketChat from '~/modules/WebSocketChat';
import { checkFeatureFlag } from '~/modules/helpers';

import Login from '~/models/Login';

import Icon from '~/components/Icon/Icon';
import AppLogo from '~/components/AppLogo/AppLogo';
import Confirm from '~/components/Confirm/Confirm';
import Translate from '~/components/Translate/Translate';
import FilterBar from '~/components/FilterBar/FilterBar';
import HoverDropDown from '~/components/HoverDropDown/HoverDropDown';

import PreferencesContext from '~/containers/Preferences/PreferencesContext';

const pathSettingsRE = /^\/(playbook|setting_general)/;

const Topbar = () => {
    const history = useHistory();
    const routerLocation = useLocation();
    const preferencesContext = useContext(PreferencesContext);
    const [showConfirm, setShowConfirm] = useState(false);
    const [mssp] = useState({ master: false, tenant: false });
    const [totalTime, setTotalTime] = useState(null);
    const [timeLeft, setTimeLeft] = useState(0);
    const [showSessionExpiringModal, setShowSessionExpiringModal] =
        useState(false);
    const [warnSessionExpiring, setWarnSessionExpiring] = useState(true);

    const theme = useTheme();
    const currentTheme = theme?.palette?.mode || 'dark';

    const countdownExpiringModal = intervalToDuration({
        start: timeLeft * 1000,
        end: 0
    });
    //ADP: default percentage of the session time remaining to pop up the user session modal
    let timeSessionRemain = 20;

    //const [dropdownIsOpen, setDropdownIsOpen] = useState(false);
    const [msspMenu, setMsspMenu] = useState([
        {
            label: <Translate message="Mssp Dashboard" />,
            href: '#mssp_dashboard'
        },
        {
            label: <Translate message="Nodes Management" />,
            href: '#mssp_nodes_management'
        },
        {
            label: <Translate message="Custom Fields" />,
            href: '#mssp-setting_user_interface|incidents'
        },
        {
            label: <Translate message="Playbook" />,
            href: '#mssp-playbook'
        }
    ]);

    const isLinkActive = item => {
        const irSubSections = ['/triage'];
        const locationPath = routerLocation.pathname;
        const itemPath = item.path;
        return (
            itemPath === locationPath ||
            ('/ir' === itemPath && locationPath.startsWith('/incident')) ||
            ('/ir' === itemPath && irSubSections.includes(locationPath)) ||
            ('/entities' === itemPath &&
                locationPath.startsWith('/entities')) ||
            locationPath.indexOf(itemPath + '|') !== -1
        );
    };

    /*
    useEffect(() => {
        //FM: check if instance is mssp instance and if is master or tenant
        // vo TODO this needs to be refactored for delivery 2
        // Instance.checkMsspLicence().then(response => {
        //     const { data } = response;
        //     setMssp({
        //         master: data.is_master,
        //         tenant: data.is_tenant
        //     });
        //     if (data?.is_master) {
        //         Mssp.getMsspNodeList().then(response => {
        //             const { data } = response;
        //             let oneIsPaired = false;
        //             //FM: check if tenants is present and is not an array
        //             if (
        //                 data?.res?.tenants &&
        //                 !Array.isArray(data.res.tenants)
        //             ) {
        //                 oneIsPaired = Object.entries(data.res.tenants).some(
        //                     element => {
        //                         return element[1].status === 'paired';
        //                     }
        //                 );
        //             }
        //             let newMsspMenu = msspMenu;
        //             if (!oneIsPaired) {
        //                 newMsspMenu.shift();
        //                 setMsspMenu(newMsspMenu);
        //             }
        //         });
        //     }
        // });
        // ebr: commented session-timeout websocket due to cypress e2e execution issues
        // openChat();
    }, []);
    */

    const gearSettingsMenu = [];

    const ref = useRef({
        featureFlagReport: checkFeatureFlag('report'),
        featureFlagFullSoar: checkFeatureFlag('full_csoar'),
        featureFlagInstantMessaging: checkFeatureFlag('instant_messaging'),
        featureFlagAutomationService: checkFeatureFlag('automation_service')
    }).current;

    const {
        featureFlagReport,
        featureFlagFullSoar,
        featureFlagInstantMessaging,
        featureFlagAutomationService
    } = ref;

    if (
        User.can([
            'setting_general',
            'group_management',
            'notification_management',
            'incident_report_management',
            'fields_management',
            'logo_management',
            'incident_labels_management',
            'triage_management',
            'license_informations_management',
            'audit_trail_access'
        ])
    ) {
        // In case of other new settings sections, remove checkFeatureFlag('instant_messaging')
        if (
            featureFlagFullSoar ||
            (featureFlagAutomationService && featureFlagInstantMessaging)
        ) {
            gearSettingsMenu.push({
                label: <Translate message="Settings" />,
                href: featureFlagFullSoar
                    ? '#general-settings'
                    : '#setting_general',
                testId: 'settings-menu'
            });
        }
    }

    if (featureFlagReport) {
        if (User.can('report_access')) {
            gearSettingsMenu.push({
                label: <Translate message="Report" />,
                href: '#report',
                testId: 'report-menu'
            });
        }
    }

    if (
        0 === CURRENT_USER.isSuperUser &&
        User.can([
            'incident_templates_access',
            'integrations_access',
            'automation_rules_access',
            'playbook_access',
            'integrations_management',
            'ark_configure',
            'incident_templates_management',
            'automation_rules_management'
        ])
    ) {
        gearSettingsMenu.unshift({
            label: <Translate message="Automation" />,
            href: '#automation-settings',
            testId: 'automation-menu'
        });
    }

    /*
    const loadingChat = useRef(null);
    const openChat = () => {
        const loadingWSUrl = `${APP_URL.webSocket}/user/session-timeout/`;
        loadingChat.current = new WebSocketChat(loadingWSUrl);
        loadingChat.current.on('message', event => {
            const { action, message } = JSON.parse(event.data);

            switch (action) {
                case 'last_activity':
                    setTimeLeft(message.session_timeout);
                    setTotalTime(message.session_timeout);
                    setWarnSessionExpiring(true);
                    break;
                case 'session_expired':
                    window.localStorage.removeItem('sessionid');
                    break;
            }
        });
    };
    */

    //ADP: decreasing countdown
    const countdownTimer = () => {
        if (timeLeft && timeLeft > 0) {
            setTimeLeft(timeLeft - 5);
        }
    };

    useEffect(() => {
        const timer = setTimeout(() => {
            countdownTimer();
        }, 5000);
        return () => {
            clearTimeout(timer);
        };
    }, [timeLeft]);

    useEffect(() => {
        //ADP: open user session Modal
        if (
            timeLeft > 0 &&
            timeLeft < (timeSessionRemain / 100) * totalTime &&
            warnSessionExpiring
        ) {
            setShowSessionExpiringModal(true);
        }
    }, [timeLeft]);

    /*
    let profileItems = [
        {
            label: <Translate message="Profile" />,
            onClick: () => {
                preferencesContext.setFilterBarString('');
                setTimeout(() => {
                    window.location.href = `#users_management|${CURRENT_USER.id}`;
                });
            }
            //href: `#users_management|${CURRENT_USER.id}`
        }
    ];
    if (!SETTINGS.USING_ONE_PLATFORM) {
        profileItems.push({
            label: <Translate message="Logout" />,
            onClick: () => {
                setShowConfirm(true);
            }
        });
    }
    */

    const intialsection = featureFlagFullSoar ? '' : 'playbook';
    const logoUrl =
        1 === APP_INFO.debug
            ? `${APP_URL.django}/ui/#${intialsection}`
            : `${APP_URL.django}/#${intialsection}`;

    return (
        <>
            <Navbar
                expand="md"
                fixed="top"
                id="topbar"
                data-sumo-test="topbar"
                collapseOnSelect={true}
            >
                <Navbar.Toggle
                    aria-controls="responsive-navbar-nav"
                    className="toggle-navbar-nav"
                />
                <Navbar.Collapse id="responsive-navbar-nav">
                    <Nav className="nav-left me-auto">
                        {[
                            {
                                url: logoUrl,
                                path: `/${intialsection}`,
                                name: (
                                    <AppLogo
                                        logoType="sidebar"
                                        className={`logo raster ${
                                            featureFlagFullSoar
                                                ? 'automation'
                                                : ''
                                        }`}
                                        height={
                                            featureFlagFullSoar
                                                ? '22px'
                                                : '27px'
                                        }
                                        theme={currentTheme}
                                    />
                                ),
                                isVisible: true
                            },
                            {
                                url: '#ir',
                                path: '/ir',
                                name: (
                                    <span className="item-name">
                                        <Translate message="Incidents" />
                                    </span>
                                ),
                                isVisible: User.can([
                                    'incident_read_only',
                                    'incident_access',
                                    'incident_access_all',
                                    'triage_read_only',
                                    'triage_access',
                                    'triage_access_all'
                                ])
                            },
                            {
                                url: '#entities',
                                path: '/entities',
                                name: (
                                    <span className="item-name">
                                        <Translate message="Entities" />
                                    </span>
                                ),
                                isVisible:
                                    0 === CURRENT_USER.isSuperUser &&
                                    User.can([
                                        // mb: #8505
                                        'objects_access'
                                    ])
                            }
                        ].map((item, index) => {
                            if (item.isVisible) {
                                const active = isLinkActive(item);
                                return (
                                    <Nav.Link
                                        eventKey={index}
                                        key={index}
                                        href={item.url}
                                        className={
                                            0 !== index
                                                ? `btn btn-sm menu-button-item`
                                                : 'menu__logo'
                                        }
                                        onClick={() => history.push(item.path)}
                                        active={active}
                                    >
                                        {item.name}
                                    </Nav.Link>
                                );
                            }
                        })}
                    </Nav>
                    {preferencesContext.section &&
                        !routerLocation.pathname.startsWith('/report') && // todo: investigate this check
                        routerLocation.pathname !== '/' && (
                            <FilterBar
                                keyMap={preferencesContext.keyMap}
                                availableQueries={
                                    preferencesContext.preferences?.query
                                }
                                updateQueries={
                                    preferencesContext.setUserQueries
                                }
                                // inputRef={() => {}}
                                section={preferencesContext.section}
                                completions={
                                    preferencesContext.columnCompletions
                                }
                            />
                        )}
                    <Nav className="nav-right" id="navbar-right">
                        {mssp.master && (
                            <HoverDropDown
                                alignMenu="right"
                                icon="group-work"
                                items={msspMenu}
                                active={routerLocation.pathname.startsWith(
                                    '/mssp'
                                )}
                            />
                        )}
                        <div className="menu-item">
                            <Tooltip
                                title={<Translate message="Support" />}
                                placement="bottom"
                                arrow
                            >
                                <Nav.Link
                                    href="#support"
                                    active={
                                        '/support' === routerLocation.pathname
                                    }
                                    onClick={() => history.push('/support')}
                                    className="menu-button-item menu-button-item-icon btn-sm"
                                >
                                    <Icon type="question-circle" size="xl" />
                                </Nav.Link>
                            </Tooltip>
                        </div>
                        <HoverDropDown
                            //dropdownIsOpen={dropdownIsOpen}
                            //setDropdownIsOpen={setDropdownIsOpen}
                            alignMenu="right"
                            icon="cog"
                            items={gearSettingsMenu}
                            active={pathSettingsRE.test(
                                routerLocation.pathname
                            )}
                        />
                        {/*{!SETTINGS.USING_ONE_PLATFORM && (
                            <HoverDropDown
                                alignMenu="right"
                                icon="user"
                                tooltip={
                                    //ADP: add timeout on tooltip like HH:mm:ss
                                    totalTime ? (
                                        <Translate
                                            message="Session expires in: {value}"
                                            values={{
                                                value: `${countdownExpiringModal.hours
                                                    .toString()
                                                    .padStart(
                                                        2,
                                                        '0'
                                                    )}:${countdownExpiringModal.minutes
                                                    .toString()
                                                    .padStart(
                                                        2,
                                                        '0'
                                                    )}:${countdownExpiringModal.seconds
                                                    .toString()
                                                    .padStart(2, '0')}`
                                            }}
                                        />
                                    ) : null
                                }
                                extraComponent={
                                    totalTime ? (
                                        <ProgressBar
                                            className="progress-session"
                                            max={totalTime}
                                            now={timeLeft}
                                            min={0}
                                        />
                                    ) : (
                                        <></>
                                    )
                                }
                                extraClass={totalTime ? 'progress-button' : ''}
                                items={profileItems}
                                active={routerLocation.pathname.startsWith(
                                    `/users_management|${CURRENT_USER.id}`
                                )}
                            />
                        )}*/}
                        {/*{SETTINGS.USING_ONE_PLATFORM &&
                            featureFlagFullSoar && (
                                <div className="menu-item">
                                    <Tooltip
                                        title={<Translate message="Profile" />}
                                        placement="bottom"
                                        arrow
                                    >
                                        <Nav.Link
                                            href={`#users_management|${CURRENT_USER.id}`}
                                            active={routerLocation.pathname.startsWith(
                                                `/users_management|${CURRENT_USER.id}`
                                            )}
                                            className="menu-button-item menu-button-item-icon btn-sm"
                                        >
                                            <Icon type="user" size="xl" />
                                        </Nav.Link>
                                    </Tooltip>
                                </div>
                            )}*/}
                    </Nav>
                </Navbar.Collapse>
            </Navbar>
            {showConfirm && (
                <Confirm
                    show={showConfirm}
                    setShow={setShowConfirm}
                    title={<Translate message="Logout" />}
                    description={
                        <Translate
                            message="Are you sure you want to logout from {name}?"
                            values={{
                                name: 'Sumo Logic Cloud SOAR'
                            }}
                        />
                    }
                    onConfirm={() => {
                        Login.logout()
                            .then(() => {
                                // FM: remove client token
                                window.localStorage.removeItem('sessionid');
                                // FM: redirect to login to avoid js errors
                                window.location.href = `${APP_URL.django}/ui/login/${window.location.hash}`;
                            })
                            .catch(exception => {
                                console.error(exception);
                                location.reload();
                            });
                    }}
                />
            )}
            {showSessionExpiringModal && (
                <Confirm
                    show={showSessionExpiringModal}
                    description={
                        <Translate
                            message={
                                0 !== timeLeft // note: better check > 0 ?
                                    ? 'Your session will expire in: {value}'
                                    : 'Session has expired'
                            }
                            values={{
                                value: `${formatDuration({
                                    hours: countdownExpiringModal.hours,
                                    minutes: countdownExpiringModal.minutes,
                                    seconds: countdownExpiringModal.seconds
                                })}`
                            }}
                        />
                    }
                    setShow={setShowSessionExpiringModal}
                    title="User Session"
                    confirmLabel="Ok"
                    onConfirm={() => {
                        setShowSessionExpiringModal(false);
                        setWarnSessionExpiring(false);
                        //ADP: reload the time if the session time has expired
                        if (timeLeft === 0) {
                            window.location.reload();
                        }
                    }}
                    onCancel={() => {
                        setShowSessionExpiringModal(false);
                        setWarnSessionExpiring(false);
                    }}
                    showCancelButton={false}
                />
            )}
        </>
    );
};

export default Topbar;
